






























































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import AuditKuantitatifRmeService, {
  BerkasRanap,
  KetepatanBerkas,
  NilaiDokumen,
  RegisterRanapAudit
} from "@/services/AuditKuantitatifRmeService";
import AuditKuantitatifRmeLaporanBangsal from "./AuditKuantitatifRmeLaporanBangsal.vue";

type KunciDokumen = "asesmen_medis" | "cppt" | "informed_consent" | "laporan_operasi" | "ringkasan_pulang";

interface FormBerkas {
  id: number | null;
  no_rkm_medis: string;
  register_id: string;
  asesmen_medis: NilaiDokumen | null;
  cppt: NilaiDokumen | null;
  informed_consent: NilaiDokumen | null;
  laporan_operasi: NilaiDokumen | null;
  ringkasan_pulang: NilaiDokumen | null;
  catatan: string;
}

const DOKUMEN: Array<{ key: KunciDokumen; label: string; singkat: string; bolehTidakAda: boolean }> = [
  { key: "asesmen_medis", label: "Asesmen Awal Rawat Inap Medis", singkat: "Asesmen", bolehTidakAda: false },
  { key: "cppt", label: "CPPT", singkat: "CPPT", bolehTidakAda: false },
  { key: "informed_consent", label: "Informed Consent", singkat: "IC", bolehTidakAda: true },
  { key: "laporan_operasi", label: "Laporan Operasi", singkat: "Lap. Op", bolehTidakAda: true },
  { key: "ringkasan_pulang", label: "Ringkasan Pulang", singkat: "Ringkasan Pulang", bolehTidakAda: false }
];

const KETEPATAN_LABEL: Record<string, string> = {
  tepat: "Tepat (≤ 2 × 24 jam)",
  terlambat: "Terlambat (> 2 × 24 jam)",
  belum_ttd: "Ringkasan Pulang belum ditandatangani",
  belum_diisi: "Ringkasan Pulang belum diisi"
};

@Component({
  components: { AuditKuantitatifRmeLaporanBangsal }
})
export default class AuditKuantitatifRmeList extends Vue {
  mode: "list" | "laporan" = "list";

  bulan: number = moment().subtract(1, "month").month() + 1;
  tahun: number = moment().subtract(1, "month").year();
  cari = "";
  loading = false;
  berkas: BerkasRanap[] = [];

  dokumen = DOKUMEN;
  bulanOptions = Array.from({ length: 12 }, (_, i) => ({
    value: i + 1,
    text: moment().month(i).format("MMMM")
  }));
  headers = [
    { text: "No. RM", value: "no_rkm_medis", width: "8%" },
    { text: "Nama", value: "nama_pasien", width: "17%" },
    { text: "Bangsal", value: "unit_pelayanan", width: "12%" },
    { text: "Tgl Pulang", value: "tanggal_pulang", width: "9%" },
    ...DOKUMEN.map(d => ({ text: d.singkat, value: d.key, align: "center", sortable: false })),
    { text: "Ketepatan RP", value: "ketepatan", align: "center", sortable: false },
    { text: "Aksi", value: "actions", align: "end", sortable: false, width: "7%" }
  ];

  dialog = false;
  form: FormBerkas = this.formKosong();
  registerItems: RegisterRanapAudit[] = [];
  registerDicari = false;
  loadingRegister = false;
  menyimpan = false;

  mounted() {
    this.muat();
  }

  get terpilih(): RegisterRanapAudit | null {
    return this.registerItems.find(r => r.register === this.form.register_id) || null;
  }

  get registerHint(): string {
    if (!this.registerDicari) return "";
    const n = this.registerItems.length;
    if (n === 0) return "Tidak ada register Rawat Inap untuk No. RM ini.";
    const bisa = this.registerItems.filter(r => !this.registerTidakBisaDipilih(r)).length;
    if (bisa === 0) return "Semua register pasien ini masih dirawat atau sudah dianalisis.";
    if (n === 1) return "Register terisi otomatis.";
    return `${n} rawat inap ditemukan — yang terbaru dipilih otomatis, ganti bila perlu.`;
  }

  get alasanTerkunci(): string {
    if (!this.form.register_id) return "Pilih register Rawat Inap terlebih dahulu.";
    if (DOKUMEN.some(d => !this.form[d.key])) return "Lengkapi isian kelima dokumen.";
    return "";
  }

  async muat() {
    if (!this.bulan || !this.tahun) return;
    this.loading = true;
    try {
      this.berkas = await AuditKuantitatifRmeService.getList({ tahun: Number(this.tahun), bulan: Number(this.bulan) });
    } finally {
      this.loading = false;
    }
  }

  formKosong(): FormBerkas {
    return {
      id: null,
      no_rkm_medis: "",
      register_id: "",
      asesmen_medis: null,
      cppt: null,
      informed_consent: null,
      laporan_operasi: null,
      ringkasan_pulang: null,
      catatan: ""
    };
  }

  bukaForm(item: BerkasRanap | null = null) {
    if (item) {
      this.form = {
        id: item.id,
        no_rkm_medis: item.no_rkm_medis,
        register_id: item.register_id,
        asesmen_medis: item.asesmen_medis,
        cppt: item.cppt,
        informed_consent: item.informed_consent,
        laporan_operasi: item.laporan_operasi,
        ringkasan_pulang: item.ringkasan_pulang,
        catatan: item.catatan || ""
      };
      this.registerItems = [
        {
          register: item.register_id,
          no_rkm_medis: item.no_rkm_medis,
          nama_pasien: item.nama_pasien,
          tanggal_lahir: item.tanggal_lahir,
          masuk: item.tanggal_admisi || "",
          jam_masuk: null,
          pulang: item.tanggal_pulang,
          jam_pulang: null,
          unit_id: item.unit_id,
          unit_nama: item.unit_pelayanan || item.unit_id,
          dpjp_id: item.dpjp_id,
          dpjp_nama: item.dpjp_nama,
          ketepatan: item.ketepatan,
          berkas_id: item.id
        }
      ];
    } else {
      this.form = this.formKosong();
      this.registerItems = [];
    }
    this.registerDicari = false;
    this.dialog = true;
  }

  async cariRegister() {
    const noRm = (this.form.no_rkm_medis || "").trim();
    if (!noRm || this.loadingRegister) return;
    this.loadingRegister = true;
    try {
      const list = await AuditKuantitatifRmeService.getRegisterRanap(noRm);
      this.registerItems = list;
      this.registerDicari = true;
      const tetap = list.find(r => r.register === this.form.register_id && !this.registerTidakBisaDipilih(r));
      const pilihan = tetap || list.find(r => !this.registerTidakBisaDipilih(r));
      this.form.register_id = pilihan ? pilihan.register : "";
      if (pilihan) this.form.no_rkm_medis = pilihan.no_rkm_medis;
    } finally {
      this.loadingRegister = false;
    }
  }

  registerTidakBisaDipilih(r: RegisterRanapAudit): boolean {
    return !r.pulang || (!!r.berkas_id && r.berkas_id !== this.form.id);
  }

  registerText(r: RegisterRanapAudit): string {
    const tgl = (d: string | null) => (d ? moment(d).format("DD-MM-YYYY") : "…");
    let teks = `${r.register} — ${r.unit_nama} — ${tgl(r.masuk)} s/d ${r.pulang ? tgl(r.pulang) : "masih dirawat"}`;
    if (r.berkas_id && r.berkas_id !== this.form.id) teks += " (sudah dianalisis)";
    return teks;
  }

  async simpan() {
    if (this.alasanTerkunci || this.menyimpan) return;
    this.menyimpan = true;
    const data = {
      no_rkm_medis: this.form.no_rkm_medis,
      register_id: this.form.register_id,
      asesmen_medis: this.form.asesmen_medis,
      cppt: this.form.cppt,
      informed_consent: this.form.informed_consent,
      laporan_operasi: this.form.laporan_operasi,
      ringkasan_pulang: this.form.ringkasan_pulang,
      catatan: this.form.catatan
    };
    try {
      if (this.form.id) {
        await AuditKuantitatifRmeService.update(this.form.id, data);
      } else {
        await AuditKuantitatifRmeService.create(data);
      }
      this.dialog = false;
      const pulang = this.terpilih && this.terpilih.pulang;
      if (pulang) {
        this.bulan = moment(pulang).month() + 1;
        this.tahun = moment(pulang).year();
      }
      await this.muat();
    } finally {
      this.menyimpan = false;
    }
  }

  async hapus(item: BerkasRanap) {
    if (!confirm(`Hapus berkas ${item.no_rkm_medis} — ${item.nama_pasien || ""}?`)) return;
    await AuditKuantitatifRmeService.destroy(item.id);
    await this.muat();
  }

  labelNilai(v: NilaiDokumen): string {
    return v === "NA" ? "—" : v;
  }

  warnaNilai(v: NilaiDokumen): string {
    return ({ L: "green", TL: "red", NA: "grey lighten-2" } as Record<string, string>)[v] || "grey";
  }

  ketepatanTeks(k: KetepatanBerkas | null): string {
    if (!k) return "-";
    if (k.status === "tidak_terbaca") return "Tidak dapat dibaca";
    if (k.kode === "T") return "T — " + KETEPATAN_LABEL.tepat;
    if (k.kode === "TT") return "TT — " + ((k.status && KETEPATAN_LABEL[k.status]) || "");
    return "Belum dihitung (< 2 × 24 jam sejak pulang)";
  }

  ketepatanKosong(k: KetepatanBerkas | null): string {
    if (!k) return "-";
    if (k.status === "tidak_terbaca") return "tidak terbaca";
    return "< 2 × 24 jam";
  }

  ketepatanTitle(k: KetepatanBerkas | null): string {
    if (!k) return "Ketepatan Ringkasan Pulang belum dapat dihitung";
    if (k.status === "tidak_terbaca") return "Data register/Ringkasan Pulang tidak dapat dibaca";
    const pulang = k.pulang_at ? moment(k.pulang_at).format("DD-MM-YYYY HH:mm") : "-";
    const ttd = k.ttd_at ? moment(k.ttd_at).format("DD-MM-YYYY HH:mm") : (k.status && KETEPATAN_LABEL[k.status]) || "-";
    return `Pulang: ${pulang} · TTD Ringkasan Pulang: ${ttd}`;
  }

  formatDate(d: string | null): string {
    return d ? moment(d).format("DD-MM-YYYY") : "";
  }
}
